import KinoklubbTicket from "components/KinoklubbTicket";
import styled from "styled-components";

const SKinoklubbTicket = styled(KinoklubbTicket)`
	flex: 1 1 100%;
	max-width: calc(50% - 5px);
	@media screen and (min-width: 640px) {
		max-width: 150px;
	}
`;

export default SKinoklubbTicket;